import { CONSTANTS } from './constants';
import { getUserId } from '../auth/selectors';

export const onLanguageChange = lang => ({
    type: CONSTANTS.ON_LANGAGE_CHANGE,
    payload: { lang }
});

export const onInvitationAccepted = invitationAccepted => ({
    type: CONSTANTS.ON_INVITATION_ACCEPTED,
    payload: { invitationAccepted }
});

export const onShowDeletedRecords = show => ({
    type: CONSTANTS.ON_SHOW_DELETED_RECORDS,
    payload: { show }
});

const onLastPreselectedDashboardMeter = (userId, id) => ({
    type: CONSTANTS.ON_SAVED_PREFERENCES_PRESELECTED_METER,
    payload: { userId, id }
});

const onLastPreselectedDashboardDevice = (userId, id) => ({
    type: CONSTANTS.ON_SAVED_PREFERENCES_PRESELECTED_DEVICE,
    payload: { userId, id }
});

const onLastPreselectedDashboardPeriod = (userId, id) => ({
    type: CONSTANTS.ON_SAVED_PREFERENCES_PRESELECTED_PERIOD,
    payload: { userId, id }
});

const onLastPreselectedDashboardGroupBy = (userId, id) => ({
    type: CONSTANTS.ON_SAVED_PREFERENCES_PRESELECTED_GROUP_BY,
    payload: { userId, id }
});

const onLastLegendVisibility = (userId, visibility) => ({
    type: CONSTANTS.ON_SAVED_PREFERENCES_LEGENDS_VISIBILITY,
    payload: { userId, visibility }
});

const onLastPreselectedDashboardRefresh = (userId, id) => ({
    type: CONSTANTS.ON_SAVED_PREFERENCES_PRESELECTED_REFRESH,
    payload: { userId, id }
});

export const onSetSmartTrainingPeriod = (from, to) => ({
    type: CONSTANTS.ON_SET_SMART_TRAINING_PERIOD,
    payload: { from, to }
});

export const onSetSmartTrainingMinWh = minWh => ({
    type: CONSTANTS.ON_SET_SMART_TRAINING_MIN_WH,
    payload: { minWh }
});

export const onSetSmartTrainingDeviceFilter = filter => ({
    type: CONSTANTS.ON_SET_DEVICE_FILTER,
    payload: { filter }
});

export const onChangeVisiblePeriod = period => ({
    type: CONSTANTS.ON_PRE_SELECTED_PERIOD_CHANGE,
    payload: { period }
});

const onSelectedDashboardMeterIds = (userId, ids) => ({
    type: CONSTANTS.ON_SAVED_SELECTED_METER_IDS,
    payload: { userId, ids }
});

const onSelectEnergyFlowPosition = (userId, position) => ({
    type: CONSTANTS.ON_SAVED_ENERGY_FLOW_POSITION,
    payload: { userId, position }
});

const onSelectChartMode = (userId, chartMode) => ({
    type: CONSTANTS.ON_SAVED_CHART_MODE,
    payload: { userId, chartMode }
});

// ===== THUNKS =====
export const changeLanguage = lang => dispatch => {
    dispatch(onLanguageChange(lang));
    setTimeout(window.location.reload.bind(window.location), 500);
};

export const setLastLegendVisibility = visibility => (dispatch, getState) => {
    const userId = getUserId(getState());
    if (userId === undefined) return;
    dispatch(onLastLegendVisibility(userId, visibility));
};

export const setLastPreselectedMeter = id => (dispatch, getState) => {
    const userId = getUserId(getState());
    if (userId === undefined) return;
    // dispatch(fetchAllSwitches(id));
    dispatch(onLastPreselectedDashboardMeter(userId, id));
};

export const setSelectedMeterIds = ids => (dispatch, getState) => {
    const userId = getUserId(getState());
    if (userId === undefined) return;
    dispatch(onSelectedDashboardMeterIds(userId, ids));
}

export const setSelectedEnergyFlowPosition = position => (dispatch, getState) => {
    const userId = getUserId(getState());
    if (userId === undefined) return;
    dispatch(onSelectEnergyFlowPosition(userId, position));
}

export const setLastPreselectedDevice = id => (dispatch, getState) => {
    const userId = getUserId(getState());
    if (userId === undefined) return;
    dispatch(onLastPreselectedDashboardDevice(userId, id));
};

export const setLastPreselectedPeriod = id => (dispatch, getState) => {
    const userId = getUserId(getState());
    if (userId === undefined) return;
    dispatch(onLastPreselectedDashboardPeriod(userId, id));
};

export const setLastPreselectedGroupBy = id => (dispatch, getState) => {
    const userId = getUserId(getState());
    if (userId === undefined) return;
    dispatch(onLastPreselectedDashboardGroupBy(userId, id));
};

export const setLastPreselectedRefresh = id => (dispatch, getState) => {
    const userId = getUserId(getState());
    if (userId === undefined) return;
    dispatch(onLastPreselectedDashboardRefresh(userId, id));
};

export const setSelectedChartMode = chartMode => (dispatch, getState) => {
    const userId = getUserId(getState());
    if (userId === undefined) return;
    dispatch(onSelectChartMode(userId, chartMode));
}
